export default function isAdmin({ store})
{
    if (! store.getters["auth/user"].isAdmin)
    {
        return 'login';
    }

    return false;
}
